import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimContractSeasonRangeGql } from '../../bimWorkOrderQueries';

const getBimWorkOrderActiveSeasonRangeId = 'bimWorkOrderActiveSeasonRange';

export const useBimWorkOrderSeasonRange = ({
    workOrderId,
    withEffect = true,
}: {
    workOrderId: number | undefined;
    withEffect?: boolean;
}) => {
    const dispatch = useDispatch();

    const getSeasonRangeVariables = useMemo(() => ({ workOrderId }), [workOrderId]);

    const [bimWorkOrderSeasonRangeData, bimWorkOrderSeasonRangeStatus, , bimWorkOrderSeasonRangeMakeRequest] =
        useRequest({
            requestId: getBimWorkOrderActiveSeasonRangeId,
            query: bimContractSeasonRangeGql,
            withEffect: withEffect && Boolean(workOrderId),
            variables: getSeasonRangeVariables,
        });

    const [bimWorkOrderActiveSeasonRangeReset] = useResetStoreData({ requestId: getBimWorkOrderActiveSeasonRangeId });

    const updateSeasonRange = useCallback(() => {
        dispatch(bimWorkOrderSeasonRangeMakeRequest(getSeasonRangeVariables));
    }, [bimWorkOrderSeasonRangeMakeRequest, dispatch, getSeasonRangeVariables]);

    return {
        bimWorkOrderSeasonRangeData: bimWorkOrderSeasonRangeData?.bimWorkOrderSeasonsRange?.data,
        bimWorkOrderActiveSeasonRangeReset,
        bimWorkOrderSeasonRangeStatus,
        bimWorkOrderSeasonRangeUpdate: updateSeasonRange,
    };
};
